/**
 * File: aria-list.js
 *
 * Import and initialize functions for Register to Vote section
 */

export default {
  rtv: document.querySelector('.wwav-register-to-vote'),
  init() {
    if (this.rtv) {
      this.render();
    }
  },
  render() {
    const buttonIcons = this.rtv.querySelectorAll('.sc_icon_as_image');
    buttonIcons.forEach(icon => {
      icon.removeAttribute('alt');
      icon.setAttribute('aria-hidden', 'true');
    })
  },
};
